import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  complaints: 0,
  estates: 0,
  tickets: 0,
  agent_request: 0,
};

const badgeSlice = createSlice({
  name: "badge",
  initialState,
  reducers: {
    addComplaint: (state, action) => {
      state.complaint = action.payload;
    },
    setBadge: (state, action) => {
      Object.keys(action.payload).map((key) => {
        console.log("🚀Log", key, action.payload[key]);
        state[key] = action.payload[key];
      });
    },
  },
});

export const { addComplaint, setBadge } = badgeSlice.actions;

export default badgeSlice.reducer;
